import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 9l3 5.063","key":"svg-0"}],["path",{"d":"M2 9l6 6","key":"svg-1"}],["path",{"d":"M2 15l6 -6","key":"svg-2"}],["path",{"d":"M22 9l-4.8 9","key":"svg-3"}],["path",{"d":"M10 12h4","key":"svg-4"}],["path",{"d":"M12 10v4","key":"svg-5"}]]

const IconMathXPlusY = createReactComponent('outline', 'math-x-plus-y', 'MathXPlusY', __iconNode);

export default IconMathXPlusY;